import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { hinweis } from '../components/Hinweise';

const TYP_LABELS = {
  anmeldung_bestaetigung: 'Anmeldungsbestätigung',
  warteliste:             'Warteliste',
  zahlung_bestaetigung:   'Zahlungsbestätigung',
  warteliste_platz_angeboten: 'Warteliste: Platzangebot',
  warteliste_abgelehnt:       'Warteliste: Abgelehnt',
  custom:                'Eigene Vorlage',
};

export default function EmailVorlagen() {
  const navigate = useNavigate();
  const [vorlagen, setVorlagen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = async () => {
    try {
      const r = await api.get('/api/admin/email-vorlagen');
      setVorlagen(r.data);
    } catch { setError('Vorlagen konnten nicht geladen werden'); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const handleDelete = async (v) => {
    if (!window.confirm(`Vorlage „${v.name}" wirklich löschen?`)) return;
    try {
      await api.delete(`/api/admin/email-vorlagen/${v.id}`);
      await load();
    } catch (err) { hinweis.fehler(err.response?.data?.error || 'Fehler beim Löschen'); }
  };

  const handleToggle = async (v) => {
    try {
      await api.put(`/api/admin/email-vorlagen/${v.id}`, { aktiv: !v.aktiv });
      await load();
    } catch { hinweis.fehler('Fehler'); }
  };

  const allgemein = vorlagen.filter(v => v.ist_allgemein);
  const spezifisch = vorlagen.filter(v => !v.ist_allgemein);

  const renderTable = (rows, title) => (
    <div style={{ marginBottom: '2rem' }}>
      <h3 style={{ fontSize: '0.95rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.75rem' }}>
        {title}
      </h3>
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <table className="data-table">
          <thead>
            <tr><th>Name</th><th>Betreff</th><th>Typ</th><th>Status</th><th>Aktionen</th></tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '2rem' }}>
                Keine Vorlagen
              </td></tr>
            )}
            {rows.map(v => (
              <tr key={v.id}>
                <td><strong>{v.name}</strong></td>
                <td style={{ fontSize: '0.85rem', color: 'var(--text-muted)', maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {v.betreff}
                </td>
                <td>
                  <span className="status-badge status-inaktiv" style={{ fontSize: '0.72rem' }}>
                    {TYP_LABELS[v.typ] || v.typ}
                  </span>
                </td>
                <td>
                  <span className={`status-badge ${v.aktiv ? 'status-aktiv' : 'status-inaktiv'}`}>
                    {v.aktiv ? 'Aktiv' : 'Inaktiv'}
                  </span>
                </td>
                <td>
                  <div style={{ display: 'flex', gap: '0.4rem' }}>
                    <button className="btn btn-secondary btn-sm" onClick={() => navigate(`/email-vorlagen/${v.id}`)}>Bearbeiten</button>
                    <button className="btn btn-secondary btn-sm" onClick={() => navigate(`/email-vorlagen/${v.id}?vorschau=1`)}>Vorschau</button>
                    <button className={`btn btn-sm ${v.aktiv ? 'btn-danger' : 'btn-success'}`} onClick={() => handleToggle(v)}>
                      {v.aktiv ? 'Aus' : 'Ein'}
                    </button>
                    {!v.ist_allgemein && (
                      <button className="btn btn-danger btn-sm" onClick={() => handleDelete(v)}>Löschen</button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">E-Mail-Vorlagen</h2>
        <button className="btn btn-primary btn-sm" onClick={() => navigate('/email-vorlagen/neu')}>+ Neue Vorlage</button>
      </div>
      <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
        Vorlagen für Anmeldungsbestätigungen, Warteliste und Zahlungsbestätigungen.
        Allgemeine Vorlagen gelten für alle Angebote; spezifische Vorlagen überschreiben diese für einzelne Angebote.
        <br /><strong>Hinweis:</strong> E-Mails werden nie ungesehen gesendet. Die Vorlagen „Warteliste: Platzangebot" (mit Antwort-Schaltflächen) und
        „Warteliste: Abgelehnt" öffnen sich beim Speichern des jeweiligen Status in der Warteliste vorausgefüllt zum Prüfen und Senden.
        Mit „Aus" wird eine Vorlage nicht mehr angeboten.
      </p>

      {error && <div className="alert alert-error">{error}</div>}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '2rem' }}><div className="loading-spinner" style={{ margin: '0 auto' }} /></div>
      ) : (
        <>
          {renderTable(allgemein, 'Allgemeine Vorlagen')}
          {renderTable(spezifisch, 'Spezifische Vorlagen (für einzelne Angebote)')}
        </>
      )}
    </div>
  );
}
